// extracted by mini-css-extract-plugin
module.exports = {"otpLabel":"registrationFields_otpLabel__j4TkX","otpErrorLabel":"registrationFields_otpErrorLabel__vXgZ8","inputStyle":"registrationFields_inputStyle__2K-zU"};